import React from 'react';

import { IconProps, StyledPath, StyledSvg } from '../iconCommons';

export const IconClose = ({ color = 'currentColor', size = 'small', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" size={size} {...props}>
        <StyledPath
            d="M6 26L26 6"
            color={color}
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <StyledPath
            d="M6 6L26 26"
            color={color}
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </StyledSvg>
);
